import { getVatNoRegex } from '../../../utils'

export const hasValidVatNumber = (vatNumber: string | null | undefined, country: string | null | undefined): boolean =>
  !!vatNumber && getVatNoRegex(country ?? undefined).test(vatNumber)
